

export interface State {
  id?: number;
  country?: string;
  state?: string;
  name?: string;
}
